



























import VueOptions from '@utils/VueOptions'
import PricingModel from '@services/PricingModel'

settings =
  name: 'VendorListingsPricingDisplay'

  vue:
    props: ['item', 'actions']

    computed:
      vendorListing: -> @ctxVendorListing(@item)
      serviceType: -> @item.pricing_model
      quantity: -> @item.quantity

      availableDates: ->
        (@item?.available_dates || []).map((date) ->
          starts_on: date.starts_on.substr(0, 10)
          ends_on: date.ends_on.substr(0, 10)
          date: date.date.substr(0, 10)
        )

      dates: ->
        return '' unless @availableDates.length
        startDate = dayjs(@availableDates[0].starts_on)
        endDate = dayjs(@availableDates[@availableDates.length - 1].starts_on)
        @uniq([startDate.format('MM/DD/YYYY'), endDate.format('MM/DD/YYYY')]).join(' - ')

export default VueOptions.vue settings
